import './reveal-on-scroll';
import './header-footer';
import './item-hover';
import './scroll-to';

import './web-comps/header-el';
import './web-comps/splide';
import './web-comps/table-el';
import './web-comps/intro-anim';
import './web-comps/text-assets-scroll';
import './web-comps/text-on-asset-list';
import './web-comps/swiper';

gsap.registerPlugin(ScrollTrigger);

